import { inject } from '@angular/core';
import { Router, type CanActivateFn, type CanMatchFn } from '@angular/router';
import { AuthorizeGuard } from '@jms/tenant/module.jms.authorisation';
import { ConfigService } from '@jms/ui/ui.standalone.services/config.service';
import { isNativeJobGanttEnabled } from './job.gantt.native.navigation';

export const nativeJobGanttCanMatch: CanMatchFn = () => {

  return isNativeJobGanttEnabled(ConfigService.environment.featureFlags);
};

export const nativeJobGanttCanActivate: CanActivateFn = () => {

  const authorize = inject(AuthorizeGuard);
  const router = inject(Router);

  // Reuse the established Gantt access policy; its canActivate denial would clear the auth token.
  if (authorize.canLoadPath('gantt/:jobId')) {
    return true;
  }

  return router.parseUrl('/login/access-denied');
};
